// TODO Import swiper and only required modules
import Swiper from 'swiper/swiper-bundle'

const sliderSwiper = () => {
  const settings = {
    grabCursor: true,
    speed: 1000,
    // loop: true,
    autoplay: {
      delay: 3500
    },
    pagination: {
      el: '.swiper-pagination'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      addIcons: false
    }
  }
  const sliders = [...document.querySelectorAll('.js-hero-slider')]
  sliders.map((slider) => new Swiper(slider, settings))
}

export default sliderSwiper
